var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVehicleEmptyStateBackground = function SvgVehicleEmptyStateBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 853,
    height: 295,
    viewBox: "0 0 853 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    x: -79.259,
    y: -79.7344,
    width: 1011.94,
    height: 454.52
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(40px)",
      clipPath: "url(#bgblur_0_328_12256_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    "data-figma-bg-blur-radius": 80,
    d: "M529.501 0.265596L0.741023 291.129L852.21 294.786L852.679 185.49L529.501 0.265596Z",
    fill: "#D1D1D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_328_12256_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(79.259 79.7344)",
    d: "M529.501 0.265596L0.741023 291.129L852.21 294.786L852.679 185.49L529.501 0.265596Z"
  })))));
};
export { SvgVehicleEmptyStateBackground as ReactComponent };
export default __webpack_public_path__ + "assets/ee76c436.svg";